import { useEffect, useState } from "react"
import { Button, Table, Modal } from 'react-bootstrap';
import enums from "../utilities/enums";
import dateUtilities from "../utilities/dateUtilities";
import arrayUtilities from "../utilities/arrayUtilities";

export const SidAddOnsModal = ({ availableList, onConfirm, onCancel}) => {
    const [selectedList, setSelectedList] = useState([])
    const handleConfirm = () => onConfirm(availableList.filter(item => selectedList.includes(item.sid)))

    return (
        <Modal size='lg' show onHide={ () => onCancel() } centered>
            <Modal.Header>
                <Modal.Title>Add SIDs</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    <Table hover>
                        <thead>
                            <tr>
                                <th>&nbsp;</th>
                                <th className='px-0'>SID</th>
                                <th>Renewal Date</th>
                                <th>Role</th>
                                <th>Admin Email</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                availableList
                                    .filter(item => !item.isDeleted && item.isEnabled)
                                    .map(
                                        sid => <tr key={sid.sid}>
                                            <td className='px-0'>
                                                <input
                                                    id={ sid.sid }
                                                    onChange={ e => setSelectedList(arrayUtilities.toggle(e.target.value, selectedList, e.target.checked)) }
                                                    className="form-check-input cursor-pointer"
                                                    type="checkbox"
                                                    checked={ selectedList.includes(sid.sid) }
                                                    value={sid.sid}
                                                />
                                            </td>
                                            <td className='px-0'>{ sid.sid }</td>
                                            <td>{ dateUtilities.formatToDateString(sid.renewalDate) }</td>
                                            <td>{ enums.UserRole[sid.role] }</td>
                                            <td>{ sid.adminEmail }</td>
                                        </tr>
                                    )
                            }
                        </tbody>
                    </Table>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button size="sm" variant='secondary' onClick={ () => onCancel() }>Cancel</Button>
                <Button size="sm" variant="primary" onClick={ () => handleConfirm()}>Confirm</Button>
            </Modal.Footer>
        </Modal>
    )
}